var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('p', [_vm._v(" Geef per product het aantal op dat je wil retourneren. ")]), _c('b-table-simple', {
    attrs: {
      "borderless": "",
      "small": ""
    }
  }, [_c('b-thead', [_c('tr', [_c('b-th', {
    staticStyle: {
      "width": "130px"
    }
  }, [_vm._v("Aantal retour")]), _c('b-th', {
    staticStyle: {
      "width": "80px"
    }
  }, [_vm._v("Aantal art.")]), _c('b-th', {
    staticStyle: {
      "width": "105px"
    }
  }, [_vm._v("Artikel nr.")]), _c('b-th', [_vm._v("Omschrijving")]), _c('b-th', [_vm._v("Reden")])], 1)]), _c('b-tbody', _vm._l(_vm.drqLinesForReturn, function (dispatchRequestLine, index) {
    return _c('b-tr', {
      key: index
    }, [_c('b-td', [_c('b-input', {
      staticClass: "d-inline-block",
      staticStyle: {
        "width": "60px"
      },
      attrs: {
        "type": "number",
        "min": 0,
        "max": dispatchRequestLine.quantity,
        "size": "sm"
      },
      model: {
        value: dispatchRequestLine.return_qty,
        callback: function ($$v) {
          _vm.$set(dispatchRequestLine, "return_qty", _vm._n($$v));
        },
        expression: "dispatchRequestLine.return_qty"
      }
    }), _c('b-button', {
      staticClass: "shadow-none",
      attrs: {
        "size": "sm",
        "variant": "link"
      },
      on: {
        "click": function ($event) {
          dispatchRequestLine.return_qty = dispatchRequestLine.quantity;
        }
      }
    }, [_vm._v(" alles ")])], 1), _c('b-td', [_vm._v(_vm._s(dispatchRequestLine.quantity))]), _c('b-td', [_vm._v(_vm._s(dispatchRequestLine.product_identifier))]), _c('b-td', [_vm._v(_vm._s(dispatchRequestLine.product_name))]), _c('b-td', [dispatchRequestLine.return_qty === 0 ? _c('span', [_vm._v(" N.v.t. ")]) : _c('b-form-select', {
      attrs: {
        "options": _vm.possibleReturnReasons,
        "size": "sm",
        "disabled": dispatchRequestLine.return_qty === 0
      },
      model: {
        value: dispatchRequestLine.return_reason,
        callback: function ($$v) {
          _vm.$set(dispatchRequestLine, "return_reason", $$v);
        },
        expression: "dispatchRequestLine.return_reason"
      }
    })], 1)], 1);
  }), 1)], 1), _c('b-row', [_c('b-col', {
    staticClass: "text-right mr-1 pb-1"
  }, [_c('b-button', {
    attrs: {
      "variant": "secondary",
      "size": "sm"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('close');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('omt.gui.general.action.close')) + " ")]), _c('b-button', {
    staticClass: "ml-2",
    attrs: {
      "variant": "primary",
      "size": "sm",
      "disabled": !_vm.canSaveChanges
    },
    on: {
      "click": _vm.confirmReturns
    }
  }, [_vm.isSaving ? _c('font-awesome-icon', {
    attrs: {
      "icon": "spinner",
      "spin": ""
    }
  }) : _vm._e(), _vm._v(" Retour bevestigen ")], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }